import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Snippets from '../components/Snippets';

function Home() {
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredSnippets, setFilteredSnippets] = useState([]);

    // Fetch filtered snippets based on search query
    useEffect(() => {
        const fetchFilteredSnippets = async () => {
            // Only fetch if the search query has 3 or more characters
            if (searchQuery.trim().length < 3) {
                setFilteredSnippets([]);  // Clear results if less than 3 characters
                return;
            }

            try {
                const response = await axios.get(`https://api.jimmybauduin.com/snippets/search?query=${searchQuery}`);
                setFilteredSnippets(response.data);
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        };

        // Debounce search requests for smoother typing experience
        const timeoutId = setTimeout(fetchFilteredSnippets, 300); // 300ms debounce
        return () => clearTimeout(timeoutId);
    }, [searchQuery]);

    return (
        <>
            <Row className="mt-4 text-center">
                <Col xs={12} md={4} className="mx-auto">
                    <Form.Control 
                        type='text'
                        placeholder="Search snippets..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </Col>
            </Row>
            {searchQuery && searchQuery.length < 3 ? (
                <Row className="mt-4 text-center">
                    <Col xs="12" md="6" className="mx-auto">
                        <p>Keep typing to search...</p>
                    </Col>
                </Row>
            ) : searchQuery && filteredSnippets.length > 0 ? (
                <Snippets snippets={filteredSnippets} />
            ) : (
                <Row className="mt-4 text-center">
                    <Col xs="12" md="6" className="mx-auto">
                        <p>{searchQuery ? "No results found." : "Type to search for snippets."}</p>
                    </Col>
                </Row>
            )}
        </>
    );
}

export default Home;
